/*
|-------------------------------------------------------------------------------
| Lobby Token Request Mark
|-------------------------------------------------------------------------------
|
| The one owner of the mark stamped on a request whose headers carried the
| Lobby credential (the shell's utils/lobby-credential.ts), so a refusal can
| be traced to whose credential was refused. Axios carries unknown config keys
| through to `response.config`, which is where the shared api client's
| token-expiry interceptor reads it back.
|
| Lives in shared because both the stamper (shell) and the reader (this
| workspace's api client) import from here; the shell can import shared, not
| the reverse. Classic's $.ajax client stamps the same key on its jqXHR by
| literal — r2.u.api.js is a concatenated script that cannot import this
| module — so the literal here and there must stay in step.
*/

export const LOBBY_TOKEN_REQUEST_MARK = 'sentWithLobbyToken';

/** Anything the mark may have been stamped on: an axios config, a jqXHR. */
export interface LobbyTokenMarkable {
  [LOBBY_TOKEN_REQUEST_MARK]?: boolean;
}

/**
 * Whether the request behind this response was sent with the Lobby
 * credential. `config` is the axios request config, which the package types
 * do not know the mark on.
 */
export function wasSentWithLobbyToken(
  response: { config?: unknown } | null | undefined
): boolean {
  const requestConfig = response?.config as
    | LobbyTokenMarkable
    | null
    | undefined;
  return requestConfig?.[LOBBY_TOKEN_REQUEST_MARK] === true;
}
